module.exports = __webpack_public_path__ + "media/recipes/113-2f501577.png";